import React, { useMemo } from "react";
import { Periods } from "../../pages/trainings";
import { Box, IconButton, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { formatDate } from "../../shared/utils/DateUtils";
import { useLocales } from "../../hooks/useLocales";

dayjs.extend(isoWeek);
type RenderDateRangeProps = {
  period: Periods;
  date: dayjs.Dayjs;
  handleDateChange: (date: dayjs.Dayjs) => void;
};

function RenderDateRange({
  handleDateChange,
  date,
  period,
}: RenderDateRangeProps) {
  const { currentLang } = useLocales();
  const renderValue = useMemo(() => {
    switch (period) {
      case "YEAR":
        return formatDate(date.toISOString(), "YYYY", currentLang as any);
      case "MONTH":
        return formatDate(date.toISOString(), "MMMM YYYY", currentLang as any);
      case "WEEK":
        const startOfWeek = formatDate(
          date.startOf("week").toISOString(),
          "D",
          currentLang as any,
        );
        const endOfWeek = formatDate(
          date.startOf("week").toISOString(),
          "D MMMM YYYY",
          currentLang as any,
        );

        return `${startOfWeek} - ${endOfWeek}`;
      default:
        break;
    }
  }, [period, date]);

  const handlePrevDate = () => {
    switch (period) {
      case "YEAR":
        return handleDateChange(date.subtract(1, "year"));
      case "MONTH":
        return handleDateChange(date.subtract(1, "month"));
      case "WEEK":
        return handleDateChange(date.subtract(1, "week"));
      default:
        break;
    }
  };
  const handleNextDate = () => {
    switch (period) {
      case "YEAR":
        return handleDateChange(date.add(1, "year"));
      case "MONTH":
        return handleDateChange(date.add(1, "month"));
      case "WEEK":
        return handleDateChange(date.add(1, "week"));
      default:
        break;
    }
  };
  return (
    <Box display={"flex"} alignItems={"center"} gap={1}>
      <IconButton onClick={handlePrevDate}>
        <Icon icon={"mingcute:left-line"}></Icon>
      </IconButton>
      <Typography variant="h6">{renderValue}</Typography>
      <IconButton>
        <Icon onClick={handleNextDate} icon={"mingcute:right-line"}></Icon>
      </IconButton>
    </Box>
  );
}

export default RenderDateRange;
